var map = {
	"./1.jpeg": 6104,
	"./2.jpeg": 7897,
	"./3.jpeg": 5682,
	"./4.jpeg": 8387,
	"./5.jpeg": 1772,
	"./6.jpeg": 1021,
	"./7.jpeg": 6054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;